import {
    PortfolioSummaryComponentState,
    initialPortfolioSummaryComponentState,
} from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';

import { createComponentStateReducer } from 'widgets/store/component/reducer';

export const portfolioSummaryComponentReducer =
    createComponentStateReducer<PortfolioSummaryComponentState>(
        initialPortfolioSummaryComponentState
    );
